import React, { useState, useEffect } from 'react'
import { Row, Form, Button, Col } from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useNewQuestionMutation } from '../../slices/students/questionsApiSlice';
import { useGetPublicsubjectQuery } from '../../slices/teachers/subjectApiSlice';
import { useGetPlanQuestionsQuery } from '../../slices/teachers/subjectApiSlice';
import { setStudentCredentials } from '../../slices/students/authStudentSlice';
import { toast } from 'react-toastify';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const StudentAskDetails = () => {

  const { id } = useParams();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [tittle, setTittle] = useState('');
    const [description, setDescription] = useState('');
    const [questionsLeft, setQuestionsLeft] = useState(0);
    const [isDisabled, setIsDisabled] = useState(true);

    const [qask, setQask] = useState(0);
    const [qleft, setQleft] = useState(0);
    const [planid, setPlanid] = useState(0);
    const [currentPlan, setCurrentPlan] = useState([]);
    const [lastdate, setLastdate] = useState();

    const { studentInfo } = useSelector((state) => state.authStudent);

    const { data } = useGetPublicsubjectQuery(id);

    const { data: data2, isLoading, error, refetch } = useGetPlanQuestionsQuery(id);

    useEffect(() => {
      refetch();
    }, []);

    useEffect(() => {
        data2?.map((pla) => {
        if (pla.active == true) {
          setCurrentPlan(pla)
        }
      });
    }, [navigate, data2])

    useEffect(() => {
      if(currentPlan) {
        setQuestionsLeft(currentPlan.questionsLeft)
        setQask(currentPlan.questionsAsked + 1)
        setQleft(currentPlan.totalQuestions - qask)
        setPlanid(currentPlan.plan)
        setLastdate(new Date(currentPlan.endDate * 1000).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"}))  
      }
  }, [navigate, currentPlan, qask])

    const [newQuestion, { isLoading: loading, error: newerror }] = useNewQuestionMutation();

    const teacher = data?.teacher;
    const subjectname = data?.tittle;

    useEffect(() => {
        if(!studentInfo) {
            navigate('/studentlogin')
        }
    }, [navigate, studentInfo])


  useEffect(() => {
    if (currentPlan.active == true && currentPlan.pastDue == false && description !== '' && tittle !== '') {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [tittle, description, currentPlan])

  const submitHandler = async (e) => {
    e.preventDefault()
    try {
          if (tittle == '') { toast.error('Please enter a tittle'); return; } 
          if (description == '') { toast.error('Please enter a description'); return; } 
          const res = await newQuestion({  tittle, subjectname, qask, qleft, planid, description, teacher,  id }).unwrap();
          const newid = res.qid;
          dispatch(setStudentCredentials({ ...res }));
          navigate(`/studentasktype/${newid}`)
          toast.success('Details Saved');
    } catch (err) {
          toast.error(err?.data?.message || err.error.message);
    }  
  };

  return (
    <div>
      <StudentNavbar />
      <div className="main-content" id="panel">
        <StudentHeader /><br /><br /><br /><br /><br />
        <div className="container-fluid mt--6">
          <div className="row">
              <div className="col-xl-8 offset-xl-2">  
                <div className="card-wrapper profileCard">
                  <div className="card profileCard2"> <br />
                    <h2 className="centerTitle tittleColor4 ">
                      <span className='tittleColor4'>Create New Question</span>
                    </h2>
                    <h6 className="centerTitle tittleColor4 ">
                      {isLoading ? ( 
                        <Loader />
                      ) : error ? (
                        <Message variant='danger'>
                          {error?.data?.message || error.error}
                        </Message>
                      ) : (     
                        <>  
                          { (currentPlan.active && currentPlan.pastDue == false)  &&               
                            <span className='tittleColor4'>
                              You have  {questionsLeft}  questions left this month  <br />
                            </span>
                          }
                          { (currentPlan.active && currentPlan.renewal && currentPlan.pastDue == false) &&                              
                            <span className='tittleColor4'>
                              Your Subscription will renew on {lastdate}
                            </span>
                          }
                          { (currentPlan.active && currentPlan.pastDue) &&                              
                            <span className='tittleColor4'>
                              Your Subscription is past due
                            </span>
                          }
                          { (currentPlan.active && currentPlan.renewal == false && currentPlan.pastDue == false) ?                                         
                              <span className='tittleColor4'>
                              Your Subscription will experire on {lastdate}
                              </span>
                          :                         
                            <span className='tittleColor4'>
                            </span>
                          }
                        </>
                      )}                   
                    </h6><br />
                    <div className="card-body">
                      <Form onSubmit={submitHandler}>
                        <div className="form-group">
                          <div className="input-group input-group-merge input-group-alternative mb-3">
                            <div className="input-group-prepend moveInput">
                              <span className="input-group-text bg-gradient-primary"><i className="ni ni-tag navText"></i></span>
                            </div>
                            <input 
                              className="form-control emailForm" 
                              placeholder="  Title" 
                              type="text" 
                              value={tittle}
                              onChange={(e) => setTittle(e.target.value)}                                              
                            />
                          </div>
                        </div><br /><br />
                        <div className="form-group">
                          <div className="input-group input-group-merge input-group-alternative mb-3">
                            <div className="input-group-prepend moveInput">
                              <span className="input-group-text bg-gradient-warning"><i className="ni ni-archive-2 navText"></i></span>
                            </div>
                            <textarea 
                              className="form-control emailForm" 
                              placeholder="  Description" 
                              rows="3"
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}                                          
                            />
                          </div>
                        </div>
                        <div className='mycard'><br /><br /><br /><br />
                          <Button disabled={isDisabled}  type='submit' variant="primary rounded-pill bg-gradient-info btn-lg "> 
                            Upload Video 
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>  
    </div>
  )
}

export default StudentAskDetails
